import { generatePath } from 'react-router-dom';
import { ResponseError } from '@backstage/errors';
import { DEFAULT_NAMESPACE } from '@backstage/catalog-model';

class BadgesClient {
  discoveryApi;
  fetchApi;
  configApi;
  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
    this.configApi = options.configApi;
  }
  static fromConfig(options) {
    return new BadgesClient(options);
  }
  async getEntityBadgeSpecs(entity, badgeOptions) {
    const obfuscate = this.configApi.getOptionalBoolean("app.badges.obfuscate");
    if (obfuscate) {
      const entityUuidUrl = await this.getEntityUuidUrl(entity);
      const entityUuid = await this.getEntityUuid(entityUuidUrl).then((data) => {
        return data.uuid;
      });
      const entityUuidBadgeSpecsUrl = await this.getEntityUuidBadgeSpecsUrl(
        entityUuid
      );
      const response2 = await this.fetchApi.fetch(entityUuidBadgeSpecsUrl);
      if (!response2.ok) {
        throw await ResponseError.fromResponse(response2);
      }
      return await response2.json();
    }
    const entityBadgeSpecsUrl = await this.getEntityBadgeSpecsUrl(
      entity,
      badgeOptions
    );
    const response = await this.fetchApi.fetch(entityBadgeSpecsUrl);
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return await response.json();
  }
  async getEntityUuidUrl(entity) {
    const routeParams = this.getEntityRouteParams(entity);
    const path = generatePath(`:namespace/:kind/:name`, routeParams);
    const baseUrl = await this.discoveryApi.getBaseUrl("badges");
    const obfuscatedEntityUrl = `${baseUrl}/entity/${path}/obfuscated`;
    return obfuscatedEntityUrl;
  }
  async getEntityUuid(entityUuidUrl) {
    const responseEntityUuid = await this.fetchApi.fetch(entityUuidUrl);
    if (!responseEntityUuid.ok) {
      throw await ResponseError.fromResponse(responseEntityUuid);
    }
    return await responseEntityUuid.json();
  }
  async getEntityUuidBadgeSpecsUrl(entityUuid) {
    const baseUrl = await this.discoveryApi.getBaseUrl("badges");
    return `${baseUrl}/entity/${entityUuid}/badge-specs`;
  }
  async getEntityBadgeSpecsUrl(entity, badgeOptions) {
    const routeParams = this.getEntityRouteParams(entity);
    const path = generatePath(`:namespace/:kind/:name`, routeParams);
    const baseUrl = await this.discoveryApi.getBaseUrl("badges");
    const queries = [];
    if (badgeOptions.style) {
      queries.push(`style=${badgeOptions.style}`);
    }
    if (badgeOptions.color) {
      queries.push(`color=${badgeOptions.color}`);
    }
    return `${baseUrl}/entity/${path}/badge-specs?${queries.join("&")}`;
  }
  // This function is used to generate the route parameters using the entity kind, namespace and name
  getEntityRouteParams(entity) {
    return {
      kind: entity.kind.toLocaleLowerCase("en-US"),
      namespace: entity.metadata.namespace?.toLocaleLowerCase("en-US") ?? DEFAULT_NAMESPACE,
      name: entity.metadata.name
    };
  }
}

export { BadgesClient };
//# sourceMappingURL=BadgesClient.esm.js.map
